import React from 'react';
import PropTypes from 'prop-types';
import PrismCodePicker from '../FormElements/PrismCodePicker';
import { withFormsy } from 'formsy-react';
import formsyUtils from './utils/formsyUtils';

class FormsyPrismCodePicker extends React.Component {
    onChange = (value) => {
        this.props.setValue(value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        const {
            isValid,
            isPristine,
            getValue,
            getErrorMessages,
            isFormDisabled,
            disabled,
            ...pickerProps
        } = this.props;

        const value = getValue();
        const pristine = isPristine();
        const errors = pristine
            ? []
            : getErrorMessages();

        return (
            <PrismCodePicker
                {...formsyUtils.cleanFormsyProps(pickerProps)}
                value={value}
                errors={errors}
                onChange={this.onChange}
                disabled={disabled || isFormDisabled()}
            />
        );
    }
}

FormsyPrismCodePicker.propTypes = {
    ...PrismCodePicker.propTypes,
    isValid: PropTypes.func.isRequired,
    isPristine: PropTypes.func.isRequired,
    getValue: PropTypes.func.isRequired,
    getErrorMessages: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    isFormDisabled: PropTypes.func
};

export default withFormsy(FormsyPrismCodePicker);
